import { getCountryFlag } from './countryCodes'
import i18n, { I18nextProvider } from './i18n'
import { changeLanguage, loadLanguage } from './languages'
import { TranslatePhrase } from './trans'

const Flags = {
  load: getCountryFlag,
}

const Language = {
  change: changeLanguage,
  load: loadLanguage,
}

const I18n = {
  I18nextProvider,
  i18n,
} as any

;(window as any).i18n = i18n

export default i18n
export { Language, Flags, I18n, TranslatePhrase }
